module.exports = __webpack_public_path__ + "static/blog53-af4dcf11f741efc54dc3669753fa8281.png";